module.exports = __webpack_public_path__ + "static/media/back.2ae5a46e.png";